import { render, staticRenderFns } from "./CardTest.vue?vue&type=template&id=2079e776"
import script from "./CardTest.vue?vue&type=script&lang=js"
export * from "./CardTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports